import Vue from "vue";
import VueI18n from "vue-i18n";
import zh from "./zh.js";
import en from "./en.js";
import yn from "./in.js";
import th from "./th.js";
import zhTW from "./zh_tw.js";
import es from "./es.js";
import pt from "./pt.js";
import { getRegion } from "../api/utils.js";
Vue.use(VueI18n); // 全局注册国际化包

const i18n = new VueI18n({
  locale: getRegion() === "hmt" ? "zh_tw" : "zh", // 初始化中文
  messages: {
    zh: zh,
    en: en,
    in: yn,
    th: th,
    "zh_tw": zhTW,
    es: es,
    pt: pt
  },
});

console.log(i18n, getRegion() === "hmt");
export default i18n;
